const translations = {
    unsubscribe: {
        header: "Gérer mes notifications",
        saveChanges: "Enregistrer mes préférences",
        glitter: {
            newRequest: "Nouvelle demande",
            newAppointment: "Nouveau rendez-vous",
            appointmentApproaching: "Rendez-vous imminent",
            appointmentCanceled: "Rendez-vous annulé",
            payoutInProcess: "Paiement en cours",
        },
        renter: {
            glitterFound: "Glitter trouvé",
            glitterApproaching: "Glitter en approche",
            glitterWriting: "Rédaction du rapport",
            requestCanceled: "Demande annulée",
            reportReceived: "Rapport reçu",
        },
        customer: "Client",
        confirmationMessage: "Vos préférences ont bien été enregistrées.",
    },
    home: {
        nav: {
            home: "Accueil",
            download: "Télécharger",
            about: "À propos",
            faq: "FAQ",
            contact: "Contact",
        },
        hero: {
            content:
                "Le nettoyage nouvelle génération. Rapide. Efficace. Sans effort !",
            callToAction: "Installez l'application maintenant !",
        },
        download: {
            title: "Téléchargez l'application dès maintenant !",
            desc: "Obtenez l'application sur votre appareil et commencez à l'utiliser dès aujourd'hui.",
            appleDownload: "Télécharger sur l'App Store",
            androidDownload: "Obtenir sur Google Play",
        },
        about: {
            title1: "Laissez-nous prendre soin de votre véhicule",
            desc1: "GlitGo est une plateforme qui connecte les utilisateurs avec des professionnels certifiés pour le nettoyage et l'inspection des véhicules. Notre objectif est de garantir que votre véhicule est en parfait état.",
            btn1: "Commencer maintenant",
            title2: "Devenez un Glitter",
            desc2: "Vous pouvez également devenir un Glitter et offrir vos services aux utilisateurs. Rejoignez notre plateforme et commencez à gagner de l'argent en fournissant des services de qualité.",
            btn2: "En savoir plus",
        },
        faq: {
            title: "Questions Fréquemment Posées",
            questions: [
                {
                    question: "Qu'est-ce que GlitGo ?",
                    answer: "GlitGo est une plateforme qui vous permet de demander des services tels que le nettoyage ou l'inspection de véhicules directement depuis votre téléphone. Des professionnels certifiés se rendent à l'emplacement de votre véhicule à l'heure que vous choisissez pour fournir le service.",
                },
                {
                    question: "Comment fonctionne GlitGo ?",
                    answer: "GlitGo vous permet de planifier des services de nettoyage ou d'inspection de véhicules à partir de votre téléphone. Les professionnels certifiés se rendent à l'endroit et à l'heure que vous choisissez pour effectuer le service.",
                },
                {
                    question: "GlitGo est-il disponible dans ma ville ?",
                    answer: "GlitGo est en cours de déploiement dans plusieurs villes. Veuillez vérifier la disponibilité sur notre application ou notre site web pour voir si nous opérons dans votre région.",
                },
                {
                    question: "Comment puis-je devenir un Glitter ?",
                    answer: "Pour devenir un Glitter, vous pouvez vous inscrire sur notre plateforme. Une fois inscrit, vous aurez accès aux outils nécessaires pour commencer à offrir vos services.",
                },
                {
                    question: "Quels sont les avantages d'utiliser GlitGo ?",
                    answer: "Utiliser GlitGo vous assure que votre véhicule est en bon état grâce à du nettoyages ou des inspections certifiés, tout en simplifiant la planification et le suivi des services.",
                },
                {
                    question: "Comment puis-je contacter GlitGo ?",
                    answer: "Vous pouvez contacter GlitGo via la section contact de notre site web ou de notre application, ou en envoyant un e-mail à notre support client à support@glitgo.com.",
                },
            ],
        },
        contact: {
            title: "Contactez-nous",
            invitation:
                "Si vous avez des questions ou des commentaires, n'hésitez pas à nous contacter par e-mail à l'adresse suivante :",
        },
    },
    footer: {
        termsOfUse: "Conditions d'utilisation",
        termsOfSale: "Conditions Générales de Vente",
        privacyPolicy: "Politique de Confidentialité",
        cookiesPolicy: "Politique des Cookies",
        copyright: "Tous droits réservés.",
    },
    emailConfirmed: {
        header: "Email confirmé",
        desc: "Votre email a été confirmé avec succès. Vous pouvez maintenant retourner à l'application et vous connecter.",
        gotoApp: "Veuillez retourner à l'application mobile pour continuer.",
    },
    forgotPassword: {
        header: "Mot de passe oublié",
        email: {
            label: "Adresse e-mail",
            errorMessage: "Veuillez entrer votre adresse e-mail",
            validEmailRequired: "Veuillez entrer une adresse e-mail valide",
            placeholder: "Entrez votre adresse e-mail",
        },
        submit: "Soumettre",
        success: "Succès",
        successDesc:
            "Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail. Veuillez vérifier votre boîte de réception et suivre les instructions.",
        error: "Erreur",
        submitting: "Envoi en cours...",
        errors: {
            tryAgainLater:
                "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
            resetLinkNotSent:
                "Une erreur s'est produite lors de l'envoi du lien de réinitialisation.",
        },
    },

    notFound: {
        message: "Oups ! La page que vous recherchez n'existe pas.",
        goHome: "Retourner à l'accueil",
    },

    resetPassword: {
        header: "Réinitialiser le mot de passe",
        newPassword: {
            label: "Nouveau mot de passe",
            placeholder: "Entrez votre nouveau mot de passe",
            emptyError: "Veuillez entrer votre nouveau mot de passe !",
            tooShortError:
                "Le mot de passe doit contenir au moins 8 caractères.",
        },
        confirmPassword: {
            label: "Confirmez le nouveau mot de passe",
            placeholder: "Confirmez votre nouveau mot de passe",
            emptyError: "Veuillez confirmer votre nouveau mot de passe !",
            noMatchError: "Les deux mots de passe ne correspondent pas !",
        },
        submitting: "Envoi en cours...",
        submit: "Soumettre",
    },

    chekerVerif: {
        text: "Redirection en cours, veuillez patienter...",
        invalidID: "Identifiant non valide.",
        failedRedirect:
            "Échec de la redirection. Veuillez réessayer plus tard.",
        errorOccurred:
            "Une erreur est survenue lors de la récupération du lien de redirection.",
        noRedirect: "Aucun lien de redirection disponible.",
    },

    chekerVerificationFinished: {
        title: "Vos mises à jour ont été soumises avec succès !",
        subTitle:
            "Votre soumission est en cours de vérification. Veuillez retourner à l'application mobile pour continuer.",
    },

    ToU: {
        header: "Conditions Générales d'Utilisation (CGU)",
        content: [
            {
                label: "1. Acceptation des Conditions",
                desc: "L'utilisation de l'application GlitGo (« Application ») est soumise aux présentes Conditions Générales d'Utilisation (« CGU »). En utilisant l'Application, vous acceptez ces CGU dans leur intégralité. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser l'Application.",
            },
            {
                label: "2. Description du Service",
                desc: "GlitGo permet aux utilisateurs de demander des services liés à la vérification et l'entretien automobile via l'Application. Les services sont fournis par des prestataires partenaires (« Prestataires ») inscrits sur la plateforme.",
            },
            {
                label: "3. Inscription et Compte",
                desc: "Pour utiliser les services de l'Application, vous devez créer un compte en fournissant des informations personnelles précises et complètes. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées sur votre compte.",
            },
            {
                label: "4. Obligations des Utilisateurs",
                desc: "Les utilisateurs doivent :\n- Fournir des informations exactes lors de la demande de services.\n- Respecter les rendez-vous et conditions établis avec les Prestataires.\n- Ne pas utiliser l'Application à des fins illégales ou interdites.",
            },
            {
                label: "5. Responsabilité",
                desc: "L’application GlitGo agit uniquement en tant qu'intermédiaire entre les utilisateurs et les Prestataires. Nous ne garantissons pas la qualité des prestations fournies par les Prestataires et ne sommes pas responsables des litiges entre les utilisateurs et les Prestataires.",
            },
            {
                label: "6. Confidentialité",
                desc: "Vos données personnelles sont collectées et traitées conformément à notre Politique de Confidentialité. Nous nous engageons à protéger vos informations et à ne pas les divulguer à des tiers sans votre consentement, sauf si la loi l'exige.",
            },
            {
                label: "7. Propriété Intellectuelle",
                desc: "Tous les droits de propriété intellectuelle liés à l'Application et à son contenu sont la propriété exclusive de GlitGo ou de ses concédants de licence. Vous n'êtes pas autorisé à utiliser ces éléments sans autorisation préalable.",
            },
            {
                label: "8. Modifications des CGU",
                desc: "GlitGo se réserve le droit de modifier ces CGU à tout moment. Les modifications seront publiées sur l'Application et entreront en vigueur dès leur mise en ligne. Votre utilisation continue de l'Application constitue une acceptation des modifications.",
            },
            {
                label: "9. Résiliation",
                desc: "GlitGo se réserve le droit de suspendre ou de résilier votre compte si vous violez les CGU ou si vous utilisez l'Application de manière abusive.",
            },
            {
                label: "10. Loi Applicable et Juridiction",
                desc: "Les présentes CGU sont régies par le droit français. Tout litige relatif à l'Application sera soumis à la compétence exclusive des tribunaux français.",
            },
        ],
    },
    GTS: {
        header: "Conditions Générales de Vente (CGV)",
        content: [
            {
                label: "1. Champ d'application",
                desc: "Les présentes Conditions Générales de Vente (« CGV ») s'appliquent à toutes les prestations de services demandées via l'application GlitGo (« Application ») et fournies par les Prestataires inscrits sur la plateforme.",
            },
            {
                label: "2. Commande et Confirmation",
                desc: "La commande de services est effectuée via l'Application. Une fois la demande confirmée, un contrat de prestation est conclu entre l'utilisateur (« Client ») et le Prestataire. GlitGo n'est pas partie au contrat de prestation et agit uniquement en tant qu'intermédiaire.",
            },
            {
                label: "3. Prix et Paiement",
                desc: "Les prix des services sont indiqués sur l'Application. Les paiements sont effectués directement au Prestataire, sauf indication contraire. GlitGo peut percevoir une commission sur les transactions effectuées via l'Application.",
            },
            {
                label: "4. Annulation et Remboursement",
                desc: "Les conditions d'annulation et de remboursement sont définies par le Prestataire. Les demandes d'annulation ou de remboursement doivent être adressées directement au Prestataire, GlitGo n'étant pas responsable de ces aspects.",
            },
            {
                label: "5. Exécution des Services",
                desc: "Les Prestataires sont responsables de l'exécution des services conformément aux conditions spécifiées dans la demande du Client. GlitGo ne garantit pas la qualité des services et n'assume aucune responsabilité en cas de non-conformité ou de litige.",
            },
            {
                label: "6. Réclamations",
                desc: "Toute réclamation relative à la prestation doit être adressée directement au Prestataire. GlitGo n'intervient pas dans le règlement des litiges entre le Client et le Prestataire.",
            },
            {
                label: "7. Confidentialité",
                desc: "Les informations personnelles collectées lors de la commande sont traitées conformément à notre Politique de Confidentialité. GlitGo s'engage à protéger les données personnelles et à ne pas les divulguer sans consentement, sauf exigence légale.",
            },
            {
                label: "8. Modifications des CGV",
                desc: "GlitGo se réserve le droit de modifier les CGV à tout moment. Les modifications seront publiées sur l'Application et entreront en vigueur dès leur mise en ligne. Votre utilisation continue de l'Application après modification constitue une acceptation des nouvelles CGV.",
            },
            {
                label: "9. Loi Applicable et Juridiction",
                desc: "Les présentes CGV sont régies par le droit français. Tout litige relatif aux prestations de services sera soumis à la compétence exclusive des tribunaux français.",
            },
        ],
    },

    privacyPolicy: {
        header: "Politique de Confidentialité",
        description:
            "Bienvenue sur GlitGo. La protection de votre vie privée est une priorité pour nous. Cette politique de confidentialité explique quelles informations nous collectons, comment nous les utilisons et les options dont vous disposez pour gérer vos données.\n\nDernière mise à jour: 6 Décembre 2025",
        content: [
            {
                label: "1. Informations Collectées",
                desc: "Nous collectons plusieurs types de données lorsque vous utilisez nos services :",
            },
            {
                label: "1.1. Informations fournies par l'utilisateur",
                desc: "- Nom, prénom\n- Adresse e-mail\n- Numéro de téléphone\n- Adresse postale\n- Informations de paiement (via des prestataires sécurisés comme Stripe)\n- Documents d'identité et de conformité requis pour les Glitters (carte d'identité ou passeport, justificatif d'immatriculation, numéros de TVA/impôts, 4 derniers chiffres du SSN lorsque Stripe le demande)\n- Coordonnées bancaires pour verser les paiements (IBAN, numéro de routage, derniers chiffres du compte)\n- Informations sur le.s véhicule.s à inspecter ou nettoyer:\n\t- Marque, modèle, année\n\t- Immatriculation\n\t- Localisation\n\t- Photos\n\t- Autres informations spécifiques",
            },
            {
                label: "1.2. Données techniques collectées automatiquement",
                desc: "- Adresse IP et zone géographique approximative\n- Modèle d'appareil, version du système, langue du navigateur, fuseau horaire et version de l'application\n- Événements d'utilisation, diagnostics, journaux d'erreurs et identifiants de requêtes enregistrés par notre backend Strapi\n- Jetons de notifications push et identifiants d'appareil générés par Apple, Google ou Expo pour livrer les alertes",
            },
            {
                label: "1.3. Données de localisation et de planification",
                desc: "- Adresses d'intervention incluant rue, notes d'accès, coordonnées latitude/longitude et créneaux choisis\n- Recherches géographiques saisies dans les applications (transmises à l'API Google Places pour suggérer des adresses)\n- Rayon d'action, zones et disponibilités définis par les Glitters",
            },
            {
                label: "1.4. Données stockées en local",
                desc: "GlitGo utilise Async Storage pour stocker certaines données localement sur votre appareil, telles que votre session active, le jeton d'actualisation, le jeton push, les demandes en attente et les brouillons de rapports (y compris les photos mises en cache) afin que vous puissiez terminer une mission hors connexion. Vous pouvez supprimer ces données en vous déconnectant, en vidant le cache ou en désinstallant l'application.",
            },
            {
                label: "1.5. Documents de vérification et de paiement",
                desc: "- Documents d'identité et de conformité transmis via Stripe Connect (nous conservons uniquement des références masquées, Stripe héberge les fichiers)\n- Identifiants fiscaux et données d'immatriculation exigés par la réglementation\n- Informations bancaires (IBAN, BIC, numéros de routage, derniers chiffres) utilisées pour effectuer les virements. Seule la portion minimale nécessaire au support est conservée ; le numéro complet reste chez Stripe.",
            },
            {
                label: "1.6. Identifiants d'appareil et notifications",
                desc: "- Jetons Expo, Apple Push Notification service et Firebase Cloud Messaging associés à votre compte pour envoyer des alertes urgentes et des rappels\n- Système d'exploitation, langue préférée et fuseau horaire de l'appareil pour personnaliser les notifications et diagnostiquer les problèmes",
            },
            {
                label: "1.7. Données tierces",
                desc: "Nous pouvons recevoir des informations de nos partenaires de paiement (ex. décisions de conformité Stripe, statut des virements), des fournisseurs de push (accusés de réception) et des services de cartographie (métadonnées d'adresse) et les associer à votre compte.",
            },
            {
                label: "2. Utilisation des informations",
                desc: "Nous utilisons vos informations pour :\n- Fournir et améliorer nos services (affectation des missions, génération de rapports d'inspection)\n- Vérifier votre identité, satisfaire aux obligations KYC/anti-fraude imposées par Stripe et traiter les paiements\n- Déterminer la disponibilité, géolocaliser les services et envoyer des rappels ou consignes de sécurité par email/push\n- Mettre en cache les rapports hors ligne afin que vous puissiez terminer une mission sans réseau\n- Assurer la sécurité, enquêter sur les abus et respecter nos obligations légales\n- Vous contacter pour des mises à jour, des offres, des rappels d'inactivité et de l'assistance",
            },
            {
                label: "3. Partage des informations",
                desc: "Nous ne vendons pas vos données personnelles. En revanche nous pouvons partager les informations strictement nécessaires avec :\n- Stripe (paiements, vérification d'identité, virements) qui traite les documents et données bancaires pour notre compte\n- Amazon Web Services et nos hébergeurs (hébergement de la plateforme et stockage S3 des photos, rapports et documents)\n- Les fournisseurs de communication tels que notre relais SMTP, Expo, Apple Push Notification service et Firebase Cloud Messaging pour l'envoi des emails et notifications push\n- Les services de cartographie et de géocodage (Google Places/Maps) lorsque vous recherchez ou validez une adresse dans les applications\n- Les outils d'analyse, de journalisation et de sécurité intégrés à notre infrastructure Strapi pour détecter la fraude\n- Les autorités compétentes, si la loi l'exige ou pour prévenir une fraude\n- Des tiers en cas de fusion ou d'acquisition, après vous en avoir informé",
            },
            {
                label: "4. Conservation des données",
                desc: "Nous conservons vos données aussi longtemps que nécessaire pour vous fournir nos services et répondre aux obligations légales.",
            },
            {
                label: "4.1. Compte inactif",
                desc: "Un compte est considéré comme inactif après 12 mois consécutifs sans connexion ni activité. Nous envoyons automatiquement un email 14 jours avant la suppression ; il suffit de se reconnecter pour annuler cette suppression. Sans action de votre part, le compte et les profils associés sont supprimés, à l'exception des données que la loi nous impose de conserver.",
            },
            {
                label: "4.2. Inscription incomplète",
                desc: "Si l'inscription n'est pas complétée dans l'heure suivant le début du processus, les informations collectées seront supprimées, ainsi que le compte.",
            },
            {
                label: "4.3. Suppression automatique des Rapports",
                desc: "Les rapports d'inspection, photos et pièces jointes sont conservés pendant 90 jours après leur validation afin que vous puissiez les télécharger. Une fois ce délai écoulé – ou dès que vous supprimez la demande/le compte correspondant – un traitement automatique efface le rapport de la base de données et supprime tous les fichiers associés sur AWS S3.",
            },
            {
                label: "5. Sécurité des données",
                desc: "Nous mettons en place des mesures de sécurité avancées pour protéger vos informations contre l'accès non autorisé, la perte ou l'altération.",
            },
            {
                label: "6. Vos droits",
                desc: "Conformément au RGPD et aux autres lois applicables, vous avez les droits suivants :\n- Accès : obtenir une copie de vos données\n- Rectification : corriger vos informations\n- Suppression : demander la suppression de votre compte\n- Opposition : refuser certaines utilisations de vos données\n- Portabilité : récupérer vos données dans un format exploitable\n\nPour exercer vos droits, contactez-nous à support@glitgo.com.",
            },
            {
                label: "7. Cookies et Technologies Similaires",
                desc: "Nous utilisons uniquement des cookies strictement nécessaires et du stockage local afin de garantir le bon fonctionnement du site (par exemple pour mémoriser la langue que vous avez choisie). Ces technologies ne servent jamais à de la publicité ou du pistage inter-sites.",
            },
            {
                label: "7.1. Détails des cookies fonctionnels",
                desc: "- Nom du cookie : i18next\n- Finalité : mémoriser la dernière langue sélectionnée afin d'afficher automatiquement le site dans cette langue lors de vos prochaines visites\n- Durée de conservation : 12 mois (le cookie est renouvelé à chaque nouvelle visite)\n- Fournisseur : site GlitGo via i18next-browser-languagedetector\n\nVous pouvez supprimer ou bloquer ce cookie à tout moment depuis les réglages de votre navigateur. Dans ce cas, le site reviendra par défaut en anglais et vous redemandera votre langue à chaque session.",
            },
            {
                label: "8. Modifications de la Politique de Confidentialité",
                desc: "Nous pouvons mettre à jour cette politique de confidentialité à tout moment. La date de dernière mise à jour figure en haut de ce document.",
            },
            {
                label: "9. Contact",
                desc: "Pour toute question concernant notre politique de confidentialité, contactez-nous à l'adresse suivante :\nsupport@glitgo.com\nGlitGo — 4 Passage des Ballades, 95800 Cergy, France",
            },
        ],
    },

    deleteAccount: {
        header: "Supprimer le compte",
        description:
            "Nous sommes désolés de vous voir partir. Veuillez sélectionner votre type de profil et suivre le guide ci-dessous pour supprimer votre compte.",
        profileTypes: {
            title: "Sélectionnez votre type de profil",
            glitter: {
                title: "Profil Glitter (GlitGo Pro)",
                description: "Compte prestataire de services professionnels",
                icon: "🧹",
            },
            customer: {
                title: "Profil Client (GlitGo)",
                description: "Compte de demande de services",
                icon: "🚗",
            },
        },
        deletionGuide: {
            title: "Comment supprimer votre compte",
            step1: {
                title: "Ouvrir l'application",
                description: "Lancez l'application GlitGo sur votre appareil",
                path: "Paramètres → Profil → Supprimer le compte",
            },
            step2: {
                title: "Confirmer la suppression",
                description:
                    "Lisez le message d'avertissement et confirmez votre décision",
            },
            step3: {
                title: "Terminer le processus",
                description:
                    "Suivez les instructions à l'écran pour finaliser la suppression du compte",
            },
            alternative: {
                title: "Méthode alternative",
                description:
                    "Si vous ne pouvez pas accéder à l'application, vous pouvez demander la suppression du compte par email",
                email: "Envoyez un email à :",
            },
        },
        warning:
            "⚠️ Attention : La suppression de compte est définitive et ne peut pas être annulée. Toutes vos données, y compris l'historique des services et les informations personnelles, seront définitivement supprimées.",
        contactEmail: "support@glitgo.com",
        contact: {
            label: "Email",
        },
        footer: "Si vous avez des questions ou besoin d'aide, n'hésitez pas à contacter notre équipe de support.",
    },
};

export default translations;
